import CloseIcon from "@mui/icons-material/Close";
import { getCegjelzoDisplayFields } from "../../utils/cegjelzo/formatCegjelzoCompanyDisplay.js";
import i18n from "../../../../utils/i18n";
import classes from "./cegjelzoSelectedCompanySummary.module.scss";

const CegjelzoSelectedCompanySummary = ({
  companyData,
  isSupportedCompanyType = true,
  unsupportedMessage,
  onRemove,
}) => {
  const fields = getCegjelzoDisplayFields(companyData);

  return (
    <div
      className={`${classes.root} ${!isSupportedCompanyType ? classes.rootUnsupported : ""}`}
    >
      <div className={classes.header}>
        <div className={classes.headerText}>
          <h2 className={classes.title}>{i18n.t("searchflow.summarytitle")}</h2>
          <p className={classes.intro}>
            {i18n.t("searchflow.summaryintro")}
          </p>
        </div>
        {typeof onRemove === "function" && (
          <button
            type="button"
            className={classes.removeButton}
            aria-label={i18n.t("searchflow.removecompanyarialabel")}
            onClick={onRemove}
          >
            <CloseIcon sx={{ fontSize: 20 }} aria-hidden="true" />
          </button>
        )}
      </div>

      {!isSupportedCompanyType && unsupportedMessage && (
        <p className={classes.unsupportedMessage}>{unsupportedMessage}</p>
      )}

      <div className={classes.fields}>
        {fields.map((field) => (
          <div key={field.label} className={classes.fieldRow}>
            <p className={classes.fieldLabel}>{field.label}</p>
            <p className={classes.fieldValue}>{field.value || "—"}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CegjelzoSelectedCompanySummary;
